module.exports = __webpack_public_path__ + "img/20191216161022827.32fe96ec.jpg";